import { vars } from '@repo/config';
import { HardDrive, type LucideIcon } from 'lucide-react';

export interface ISysToolItem {
  title: string;
  url: string;
  icon: LucideIcon;
}

export function getSysToolItems(): ISysToolItem[] {
  return [{ title: 'Media Vault', url: `${vars.url.vaultUrl}/ui`, icon: HardDrive }];
}
